import React from "react";
import ManageDocumentsPage from "./ManageDocumentsPage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface ManageDocumentsPageContainerProps extends RouteProps, withValidUserRoleProps {}

const ManageDocumentsPageContainer = (props: ManageDocumentsPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <ManageDocumentsPage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(ManageDocumentsPageContainer);
